// extracted by mini-css-extract-plugin
export var barContainer = "_54-0";
export var extraThin = "_54-3";
export var fillBar = "_54-6";
export var fillContainer = "_54-4";
export var overflow = "_54-8";
export var overflowContainer = "_54-5";
export var regular = "_54-7";
export var thick = "_54-1";
export var thin = "_54-2";